// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__dwgv7","description":"MealItem_description__MIHnF","price":"MealItem_price__-Y8OE"};